export const MANAGED_BY_OPTIONS = [
  { label: 'Refera', value: 'refera' },
  { label: 'Minha empresa', value: 'my_company' },
]
